import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import style from './MoreMenu.module.css';

export default function MoreMenu({ children }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const myChildren = React.Children.map(children, child => React.cloneElement(child, { onClick: () => {
    setAnchorEl(null);
    child.props.onClick();
  } }));

  return (
    <React.Fragment>
      <div className={style.moreBtn}>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      </div>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={onClose}
        size="small"
        PaperProps={{
          style: {
            width: '240px',
            borderRadius: '0',
            border: '1px solid var(--gray_dark)',
          },
        }}
        MenuListProps={{
          disablePadding: true,
        }}
      >
        {myChildren}
      </Menu>
    </React.Fragment>
  );
}

MoreMenu.propTypes = {
  children: PropTypes.node,
  isClosed: PropTypes.bool,
};
